import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TitleService } from './services/hasTitle.service';
import { HeaderComponent } from './components/header.component';
import { SidebarComponent } from './components/sidebar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { BottomNavComponent } from './components/bottom-nav/bottom-nav.component';
import { ToastComponent } from './components/toast/toast.component';
import { CommonModule } from '@angular/common';
import { LanguageService } from './services/language.service';
import { LoaderService } from './services/loader.service';
import { routeAnimations } from './core/animations/route-animations';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, LoaderComponent, BottomNavComponent, ToastComponent, CommonModule],
  templateUrl: './app.html',
  animations: [routeAnimations]
})
export class App implements OnInit {
  protected readonly title = signal('ma-franchise');

  constructor(
    private titleService: TitleService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    public loaderService: LoaderService
  ) {
    const titleIsSet = this.titleService.getHasTitleFromUrl();
    this.titleService.setHasTitle(titleIsSet);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.languageService.setLanguage(lang);
      }
    });
  }

  closeSidebar() {
    // Kept for sidebar linkClick event compatibility
  }
}
